/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState, useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';

import { BrowserView, MobileView } from 'react-device-detect';

// Import Styles
import styled from 'styled-components';
import colors from '../../config/colors';
import Container from '../../components/Layout/Container';
import Row from '../../components/Layout/Row';
import history from '../../utils/history';
import Col4 from '../../components/Layout/Grid/Col4';
import Col8 from '../../components/Layout/Grid/Col8';

import H1 from '../../components/Headings/H1';
import P from '../../components/Paragraph';
import NoResultsStyle from '../../components/NoResults/NoResultsStyle';

import Filters from './Filters/Loadable';

import CustomHelmet from '../../components/Helmet';
import { LoadOverlaySticky } from '../../components/Animations';
import { paginateScroll } from '../ScrollToTop';
import FiltersModal from './Modal/filters';

// Icons

import CityBg from '../../assets/Icons/jobs-city.webp';

// Import Model
import { Job } from '../../models/jobs';

// Pagination
import ReactPaginate from 'react-paginate';
import PaginateWrapper from '../../components/Pagination';

// Import Selectors
import {
  makeSelectJobs,
  makeSelectJobsLoading,
  makeSelectCurrentPage,
  makeSelectPageCount,
  selectCitySeo,
} from './selectors';
import { optionsFilterJobs } from '../../config/selectOptions';

import { optionsCitySelector } from './Filters/selectors';

// Import Actions
import { getAllJobs, getCityAction } from './actions';

// Import Messages
import { FormattedMessage } from 'react-intl';
import generalMessages from '../generalMessages';
import messages from './messages';

import { encodeData } from '../../utils/url';
import { BASE_URL } from '../../config/config';
import {
  PageTitle,
  PageTitleContainer,
  PageTitleText,
} from '../../components/PageSections/PageTitle';
import ActiveJobCard from '../../components/PageSections/Job/ActiveJobCard';
import { Heading } from '../../components/PageSections/Heading';
import MainWrapper from '../../components/PageSections/MainWrapper';
import SelectFilter from '../../components/Inputs/SelectFilter';
import H2 from '../../components/Headings/H2';

const Jobs: FC = () => {
  let { search, pathname } = useLocation();
  let parsed = queryString.parse(search);

  const seoParams: any = useParams();
  const city =
    parsed && parsed.city
      ? parsed.city
      : seoParams.city
      ? seoParams.city
      : seoParams.grad
      ? seoParams.grad
      : '';
  const fieldOfWork =
    parsed && parsed.field_of_work
      ? parsed.field_of_work
      : seoParams.fieldOfWork
      ? seoParams.fieldOfWork
      : '';

  const fieldOfWorkLabel =
    fieldOfWork.charAt(0).toUpperCase() + fieldOfWork.slice(1);

  const apiUrl: string | undefined = BASE_URL;

  const dispatch = useDispatch();

  const jobList = useSelector(makeSelectJobs);
  const loading = useSelector(makeSelectJobsLoading);
  const pageCount = useSelector(makeSelectPageCount);
  const currentPage = useSelector(makeSelectCurrentPage);
  const optionsCity = useSelector(optionsCitySelector);
  const citySeo = useSelector(selectCitySeo);

  const [filterJobs, setFilterJobs] = useState<string>('');
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [filterResults, setFilterResults] = useState<Array<string | null>>([]);

  useEffect(() => {
    if (jobList && jobList.length) {
      paginateScroll();
    }
  }, [jobList]);

  const closeMenu = useCallback(
    (isOpen: boolean) => {
      setMenuOpen(isOpen);
    },
    [setMenuOpen]
  );

  const toggleMenu = useCallback(
    (e) => {
      setMenuOpen(!menuOpen);
    },
    [menuOpen]
  );

  useEffect(() => {
    if (city) {
      dispatch(getCityAction(city));
    }
  }, [city]);

  useEffect(() => {
    let parsed = queryString.parse(search);
    let page = parsed['page'] ? parsed['page'] : 1;

    if (city) {
      parsed['grad'] = city;
    }

    if (fieldOfWork) {
      parsed['kategorija'] = fieldOfWork;
    }

    if (!(parsed.modal === 'true' || parsed.modal === 'false')) {
      dispatch(getAllJobs(page, filterJobs, encodeData(parsed)));
    }
  }, [dispatch, search, filterJobs, city, fieldOfWork]);

  const handlePageClick = useCallback(
    (data: any) => {
      let page = data.selected >= 0 ? data.selected + 1 : 0;
      parsed['page'] = page;
      if (city) {
        parsed['grad'] = city;
      }
      if (fieldOfWork) {
        parsed['kategorija'] = fieldOfWork;
      }

      const query = new URLSearchParams(parsed).toString();
      history.push({
        pathname: pathname,
        search: query,
      });
    },
    [dispatch, search, filterJobs, city, fieldOfWork]
  );

  return (
    <JobsWrapper>
      <CustomHelmet
        title={
          optionsCity.length && optionsCity[0].label
            ? 'Posao ' + optionsCity[0].label
            : fieldOfWork
            ? 'Poslovi ' + fieldOfWorkLabel
            : 'Tražiš posao? Na pravom si mestu, imamo oglas za tebe!'
        }
        pageUrl={
          pathname
            ? pathname
            : optionsCity[0]
            ? pathname + '/grad/' + optionsCity.value
            : fieldOfWork
            ? pathname + '/kategorija' + fieldOfWork
            : ''
        }
        description={
          optionsCity.length && optionsCity[0].label
            ? `Tražiš posao? ${optionsCity[0].label} ima raznovrsnu ponudu poslovnih oglasa na našem sajtu! loop pomaže kandidatima i poslodavcima da pronađu jedni druge. Pronađi posao već danas!`
            : 'Tražiš posao? Uđi u loop i poveži se sa našim konsultantima. Pretraži oglase za posao po kompaniji, industriji, lokaciji i ostalim filterima. Pronađi svoj budući posao već danas!'
        }
        ogImage={
          apiUrl
            ? apiUrl.substring(0, apiUrl.length - 4) + '/images/home_og.png'
            : ''
        }
      />
      <PageTitle>
        <PageTitleContainer>
          <PageTitleText>
            <H1>
              {optionsCity.length && optionsCity[0].label ? (
                'Posao ' + optionsCity[0].label
              ) : fieldOfWork ? (
                'Poslovi ' + fieldOfWorkLabel
              ) : (
                <FormattedMessage {...messages.Header} />
              )}
            </H1>
            <P>
              <FormattedMessage {...messages.Text} />
            </P>
          </PageTitleText>
        </PageTitleContainer>
      </PageTitle>
      <JobsFiltersWrapper>
        {filterResults.length ? (
          <FiltersRewiew>
            <Container>
              <FiltersRewiewInfo>
                {filterResults.map((result: string | null, i: number) => {
                  return result ? (
                    <li key={i}>
                      <svg className="isvg">
                        <use xlinkHref={`#check-list`} />
                      </svg>
                      {result}
                    </li>
                  ) : null;
                })}
              </FiltersRewiewInfo>
            </Container>
          </FiltersRewiew>
        ) : null}
        <Container>
          <MainWrapper>
            <Heading>
              <H2>
                <FormattedMessage {...messages.ActiveJobs} />
              </H2>
              <SelectFilter
                options={optionsFilterJobs}
                value={filterJobs}
                onSelectChange={setFilterJobs}
                defaultOption={''}
                defaultOptionLabel={''}
              />
            </Heading>
            <Row>
              <Col4Job>
                <FiltersWrapper>
                  <BrowserView>
                    <Filters
                      searchResults={(value: any) => {
                        setFilterResults(value);
                      }}
                    />
                  </BrowserView>
                </FiltersWrapper>
              </Col4Job>
              <Col8Job className={'root'}>
                {loading ? (
                  <LoadOverlaySticky />
                ) : (
                  <>
                    {jobList && jobList.length > 0 ? (
                      jobList.map((item: Job, i: number) => {
                        return <ActiveJobCard item={item} key={i} />;
                      })
                    ) : jobList && jobList.length === 0 ? (
                      <NoResultsStyle>
                        <P>
                          <FormattedMessage {...generalMessages.NoResults} />
                        </P>
                      </NoResultsStyle>
                    ) : null}
                    {pageCount > 1 && (
                      <PaginateWrapper>
                        <ReactPaginate
                          previousLabel={
                            <svg>
                              <use xlinkHref={`#arrow-left`} />
                            </svg>
                          }
                          nextLabel={
                            <svg>
                              <use xlinkHref={`#arrow-right`} />
                            </svg>
                          }
                          pageCount={pageCount}
                          forcePage={currentPage - 1}
                          marginPagesDisplayed={1}
                          hrefBuilder={(page: number) => {
                            parsed['page'] = page;
                            const query = new URLSearchParams(
                              parsed
                            ).toString();
                            return pathname + '?' + query;
                          }}
                          pageRangeDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName={'pagination-white'}
                          disabledClassName={'disabled'}
                          activeClassName={'active'}
                        />
                      </PaginateWrapper>
                    )}
                  </>
                )}
              </Col8Job>
            </Row>
          </MainWrapper>
          {city ? (
            <JobsCity style={{ backgroundImage: `url(${CityBg})` }}>
              {citySeo ? citySeo.description : ''}
            </JobsCity>
          ) : null}
        </Container>
      </JobsFiltersWrapper>
      <FilterToggle onClick={toggleMenu} className={menuOpen ? 'hidden' : ''}>
        <svg>
          <use xlinkHref={`#search-light`} />
        </svg>
        Filteri
      </FilterToggle>
      <MobileView>
        <FiltersModal
          closeModal={closeMenu}
          isOpen={menuOpen}
          searchResults={(value) => {
            // executeScroll(filtersRewiewRef);
            setFilterResults(value);
          }}
        />
      </MobileView>
    </JobsWrapper>
  );
};

const JobsWrapper = styled.div``;

const JobsCity = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  align-content: center;
  visibility: hidden;
  height: 0;

  @media (max-width: 767px) {
    padding: 30px 0;
  }

  &:before {
    content: '';
    background: ${colors.WHITE};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`;

const JobsFiltersWrapper = styled.div``;

const Col4Job = styled(Col4)`
  @media (max-width: 1025px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

const Col8Job = styled(Col8)`
  padding-top: 20px;
  background: ${colors.GRAY_EXTRA_LIGHT};
  @media (max-width: 1025px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`;

const FiltersRewiew = styled.div`
  padding: 16px 0;
  display: none;
  position: sticky;
  top: 88px;
  z-index: 2;

  @media (max-width: 767px) {
    display: block;
  }
`;

const FiltersRewiewInfo = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background: ${colors.WHITE_COLOR};
  box-shadow: 0 0 20px ${colors.SHADOW_GRAYDARK};
  border: 1px solid rgba(93, 93, 93, 0.18);
  border-radius: 10px;
  padding: 6px 12px;

  li {
    font-size: 12px;
    margin: 3px 8px 3px 0;

    &:last-child {
      margin: 3px 0;
    }

    img,
    .isvg {
      width: 12px;
      height: 10px;
      margin-right: 2px;
    }

    svg {
      width: 10px;
      height: 8px;
      margin-right: 2px;
      fill: ${colors.GREEN_COLOR};
    }
  }
`;

const FiltersWrapper = styled.div`
  .filters {
    top: auto;
    max-width: 100%;
  }
`;

const FilterToggle = styled.div`
  position: fixed;
  bottom: 35px;
  right: 50%;
  transform: translateX(50%);
  z-index: 3;
  display: none;
  background: ${colors.WHITE_COLOR};
  border: 2px solid ${colors.ORANGE_COLOR};
  box-shadow: 0 0 20px rgba(93, 93, 93, 0.16);
  padding: 8px 34px;
  border-radius: 10px;
  font-size: 14px;
  color: ${colors.TEXT_BLACK};
  letter-spacing: 0.5px;
  font-weight: 600;
  transition: all 300ms ease-in-out;

  @media (max-width: 767px) {
    display: flex;
    align-items: center;
  }

  svg {
    width: 15px;
    height: 15px;
    fill: ${colors.TEXT_BLACK};
    margin-right: 6px;
  }

  &.hidden {
    bottom: -40px;
    opacity: 0;
  }
`;

export default Jobs;
